import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../state/store";
import { fetchAllOutputBrands } from "./outputSegmentDeepDiveAPI";

export interface MetricsState {
  outputBrands: string[];
  selectedOutputBrands: string[];
  loading: boolean;
  error: string;
}

const initialState: MetricsState = {
  outputBrands: [],
  selectedOutputBrands: [],
  loading: false,
  error: "",
};

export const fetchOutputBrands = createAsyncThunk(
  "outputBrands/fetchOutputBrands",
  async (payload: any, {}) => {
    try {
      const response = await fetchAllOutputBrands(payload);
      return response.brand;
    } catch (error) {
      throw error;
    }
  }
);

const outputBrandsSlice = createSlice({
  name: "outputBrands",
  initialState,
  reducers: {
    updateSelectedOutputBrands: (state, action: PayloadAction<string[]>) => {
      state.selectedOutputBrands = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOutputBrands.pending, (state) => {
      state.loading = true;
      state.outputBrands = [];
      state.selectedOutputBrands = [];
    });
    builder.addCase(fetchOutputBrands.fulfilled, (state, action) => {
      state.loading = false;
      state.outputBrands = action.payload;
      state.selectedOutputBrands =
        state.selectedOutputBrands.length === 0
          ? action.payload
          : state.selectedOutputBrands;
    });
    builder.addCase(fetchOutputBrands.rejected, (state) => {
      state.loading = false;
      state.error = "Something went wrong";
    });
  },
});

export const { updateSelectedOutputBrands } = outputBrandsSlice.actions;

export const selectOutputBrands = (state: RootState) =>
  state.outputBrands.outputBrands;
export const selectSelectedOutputBrands = (state: RootState) =>
  state.outputBrands.selectedOutputBrands;
export const selectLoading = (state: RootState) => state.outputBrands.loading;

export default outputBrandsSlice.reducer;
